export const measurementsHe = {
    "mm": "מ״מ",
    "cm": "ס״מ",
    "kg": "ק״ג",
    "ton": "טון",
    "unit": "יחידה",
    "units": "יחידות",
    "ILS": "ש״ח",
    "zol": "צול"
}